import React, { useState, useEffect } from 'react';
import { Home, Utensils, Globe, Search, Phone, LogIn, User, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const Sidebar = ({ isOpen, toggleMenu }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useCart();
    const [activeSection, setActiveSection] = useState('home');

    useEffect(() => {
        const sections = ['home', 'countries', 'search', 'menu', 'contact'];
        const handleScroll = () => {
            const scrollPosition = window.scrollY + 100;

            for (const section of sections) {
                const element = document.getElementById(section);
                if (element) {
                    const { offsetTop, offsetHeight } = element;
                    if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
                        setActiveSection(section);
                    }
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollTo = (id) => {
        if (location.pathname !== '/') {
            navigate('/');
            setTimeout(() => {
                const element = document.getElementById(id);
                if (element) element.scrollIntoView({ behavior: 'smooth' });
            }, 500);
        } else {
            const element = document.getElementById(id);
            if (element) element.scrollIntoView({ behavior: 'smooth' });
        }
        setActiveSection(id);
        if (window.innerWidth < 1024) toggleMenu(); // Close on mobile after click
    };

    return (
        <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
            <div className="sidebar-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="logo" style={{ cursor: 'pointer', marginBottom: 0 }} onClick={() => navigate('/')}>
                    <span>Global</span>Bites
                </div>
                <div className="mobile-only" onClick={toggleMenu} style={{ cursor: 'pointer', display: 'none' }}>
                    <X size={28} color="white" />
                </div>
            </div>

            <nav className="sidebar-nav" style={{ marginTop: '3rem' }}>
                <div
                    className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
                    onClick={() => scrollTo('home')}
                >
                    <Home size={22} /> Home
                </div>
                <div
                    className={`nav-link ${activeSection === 'menu' ? 'active' : ''}`}
                    onClick={() => scrollTo('menu')}
                >
                    <Utensils size={22} /> Full Menu
                </div>
                <div
                    className={`nav-link ${activeSection === 'countries' ? 'active' : ''}`}
                    onClick={() => scrollTo('countries')}
                >
                    <Globe size={22} /> Countries
                </div>
                <div
                    className={`nav-link ${activeSection === 'search' ? 'active' : ''}`}
                    onClick={() => scrollTo('search')}
                >
                    <Search size={22} /> Search
                </div>
                <div
                    className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}
                    onClick={() => scrollTo('contact')}
                >
                    <Phone size={22} /> Contact
                </div>
            </nav>

            <div className="sidebar-footer">
                {user ? (
                    <div className="nav-link" style={{ color: 'var(--primary)', fontWeight: '700' }}>
                        <User size={22} /> {user.name}
                    </div>
                ) : (
                    <button className="nav-link" onClick={() => { navigate('/login'); if (window.innerWidth < 1024) toggleMenu(); }}>
                        <LogIn size={22} /> Login
                    </button>
                )}
            </div>
        </aside>
    );
};

export default Sidebar;
